var _require = require('./typeCheck'),
    isString = _require.isString;

module.exports = function (arr, key) {
  return !Array.isArray(arr) || !isString(key);
};